import React, { useState } from 'react'
import { Edit } from 'lucide-react'
import CustomModal from '../../ui/CustomModal'
import { useTranslation } from 'react-i18next'
import { GiftCategory } from '../../../types/modules/admin/giftCategory.type'
import { Link } from 'react-router-dom'
import UpdateGiftCategoryForm from './UpdateGiftCategoryForm'
import { formatNumber } from '../../../utils/formatNumber'
import { PermissionGate } from '../PermissionGate'
import { PermissionsKey } from '../../../data/permissions'

type Props ={
    gift:GiftCategory
}

function GiftCategoryItem({gift}:Props) {
        const [isOpen, setIsOpen] = useState(false);
        const {t}= useTranslation();
        const enName = gift.languages.find(s=>s.languageCode==="en")?.name ||"";
        const arName = gift.languages.find(s=>s.languageCode==="ar")?.name ||"";
  return (
    <>
        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
        {formatNumber(gift.id)}
        </td>   

        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
        {enName}
        </td>

        <td className="p-3 min-w-[200px] text-Black font-normal text-justify">
            {arName}
        </td>

        <PermissionGate permissions={[PermissionsKey.ViewGiftCategory]}>
             <td className="p-3 min-w-[200px] text-Black font-normal text-justify capitalize">
                <Link to={`/admin/gift-templates/${gift.id}`} className=' underline'>
                    {t("view")}
                </Link>
            </td>
        </PermissionGate>

        <PermissionGate permissions={[PermissionsKey.UpdateGiftCategory]}>
            <td className="p-3 min-w-[200px] text-Black font-normal">
                <button onClick={()=>setIsOpen(p=>!p)}>
                    <Edit/>
                </button>
            </td>
        </PermissionGate>
        <CustomModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={t('update_information')}
        >
        <UpdateGiftCategoryForm
        id={gift.id}
        defaultValues={{
            languages: [
            { languageCode: "en", title: enName },
            { languageCode: "ar", title: arName },
            ],
        }}
        onSubmitSuccess={()=>{
            setIsOpen(p=>false)
        }}
        />

        </CustomModal>
    </>
  )
}

export default GiftCategoryItem